import { components } from '../../tokens/components/cobalt/OP';
import { createTheme } from '../../tokens/createTheme';
import type { DeprecatedTheme } from '../types';
import colors from './colors/OP';
import alertTokens from './components/alert.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import pillTokens from './components/pill.tokens';
import sliderTokens from './components/slider.tokens';
import { ED } from './ED';

const { borders, space, fontSizes, sizes, lineHeights } = ED;

const fontSizeBody = fontSizes.body;
const drawerHeader = drawerHeaderTokens({
  colors,
  borders,
  space,
});
const slider = sliderTokens({
  colors,
  sizes,
  space,
  fontSizeBody,
});
const checkbox = checkboxTokens({
  borders,
  colors,
  space,
  lineHeights,
  fontSizeBody,
  sizes,
});
const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});

const pill = pillTokens({ colors });
const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const COBALT_OP: DeprecatedTheme = createTheme(
  'cobalt',
  {
    ...ED,
    colors: {
      ...colors,
      text: colors,
      drawerHeader: drawerHeader.colors,
      slider: slider.colors,
      checkbox: checkbox.colors,
      brandedProgressBar: colors.primary['50'],
      input: input.colors,
      alert: alert.colors,
      pill: pill.colors,
      brandedHeaderBg: colors.primary['90'],
      calendar: calendar.colors,
    },
    borders: {
      ...borders,
      alert: alert.borders,
    },
  },
  components
);

export default COBALT_OP;
